import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideoGenerationRoute = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 5,
			width: 14,
			height: 14,
			rx: 3,
			stroke: "currentColor",
			strokeWidth: 1.8
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 10L21 7.8V16.2L17 14",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 9L13.5 12L8.5 15V9Z",
			fill: "currentColor"
		})
	]
});
export default SvgVideoGenerationRoute;
